// Store Locator Configuration
let markersvg =
  "https://cdn.shopify.com/s/files/1/0566/5197/2710/files/Fler_Pin_Marker_Store_Locator.svg?v=1750665469";
let mapcluster1 =
  "https://cdn.shopify.com/s/files/1/0566/5197/2710/files/53x53_Fler_Macro_Area_Store_Locator.svg?v=1750662151";
let mapcluster2 =
  "https://cdn.shopify.com/s/files/1/0566/5197/2710/files/56x56_Fler_Macro_Area_Store_Locator.svg?v=1750662150";
let mapcluster3 =
  "https://cdn.shopify.com/s/files/1/0566/5197/2710/files/66x66_Fler_Macro_Area_Store_Locator.svg?v=1750662150";
let mapcluster4 =
  "https://cdn.shopify.com/s/files/1/0566/5197/2710/files/78x78_Fler_Macro_Area_Store_Locator.svg?v=1750662150";
let mapcluster5 =
  "https://cdn.shopify.com/s/files/1/0566/5197/2710/files/90x90_Fler_Macro_Area_Store_Locator.svg?v=1750662151";

const SHOP = "fler-world.myshopify.com";
const TOKEN = "5ff5779930cad4fe960796f976e47d32";
const METAOBJECT_TYPE = "resellers";
const API_VERSION = "2023-10";
const ENDPOINT = `https://${SHOP}/api/${API_VERSION}/graphql.json`;

/* Fetch all resellers from Shopify GraphQL API */
async function fetchAllResellers() {
  let hasNextPage = true;
  let endCursor = null;
  const allStores = [];

  const query = `
    query GetMetaobjects($first: Int!, $after: String) {
      metaobjects(type: "${METAOBJECT_TYPE}", first: $first, after: $after) {
        edges {
          node {
            fields { key value }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `;

  while (hasNextPage) {
    const response = await fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": TOKEN,
      },
      body: JSON.stringify({
        query,
        variables: {
          first: 100,
          after: endCursor,
        },
      }),
    });

    const result = await response.json();

    if (result.errors) {
      console.error("GraphQL errors:", result.errors);
      break;
    }

    const data = result.data.metaobjects;

    for (const edge of data.edges) {
      const entry = {};
      for (const field of edge.node.fields) {
        entry[field.key] = field.value;
      }
      /* Always push the entry, even if some fields are missing */
      allStores.push(entry);
    }

    hasNextPage = data.pageInfo.hasNextPage;
    endCursor = data.pageInfo.endCursor;
  }

  return allStores;
}

/* Initialize store locator when data is fetched */
fetchAllResellers().then((stores2) => {
  /* console.log("Fetched stores:", stores2); */
  window.allStores = stores2;
  initStoreLocator(stores2);
  document.querySelector("#sl-loader").classList.add("!hidden");
});

/* Global variables */
let map;
let markers = [];
let markerCluster;
let geocoder;
let mapInitialized = false;
let autocomplete;
let itemsPerPage = 20;
let currentPage = 0;
let filteredStores = [];
let currentListStores = [];
let isProgrammaticZoom = false;
let lastSearchQuery = "";
let lastSearchLocation = { city: "", region: "", country: "" };
let stores = [];
let selectedStoreId = null;

/* Initialize store locator with fetched data */
function initStoreLocator(fetchedStores) {
  stores = fetchedStores.map((store, index) => ({
    ...store,
    pincode: store.zip || "",
    lat: parseFloat(store.latitude),
    lng: parseFloat(store.longitude),
    id: index,
  }));
  currentListStores = stores;
  initMap();
}

/* Utility functions */
function getPageLanguage() {
  return document.documentElement.lang || "en-US";
}

function parseLocationComponents(place) {
  const components = { city: "", region: "", country: "" };

  if (place.address_components) {
    place.address_components.forEach((component) => {
      const types = component.types;
      if (
        types.includes("locality") ||
        types.includes("administrative_area_level_2")
      ) {
        components.city = component.long_name;
      }
      if (types.includes("administrative_area_level_1")) {
        components.region = component.short_name;
      }
      if (types.includes("country")) {
        components.country = component.short_name;
      }
    });
  }

  return components;
}

function calculateDistance(lat1, lng1, lat2, lng2) {
  const location1 = new google.maps.LatLng(lat1, lng1);
  const location2 = new google.maps.LatLng(lat2, lng2);
  const distance = google.maps.geometry.spherical.computeDistanceBetween(
    location1,
    location2
  );
  return Math.round((distance / 1000) * 10) / 10;
}

/* Google Analytics tracking functions */
function trackSearchBarClick() {
  if (typeof dataLayer !== "undefined") {
    dataLayer.push({
      event: "store_locator_click_searchbar",
      language: getPageLanguage(),
    });
  }
}

function trackSearchCompleted(searchQuery, resultsCount, locationComponents) {
  if (typeof dataLayer !== "undefined") {
    const eventData = {
      event: "store_locator_search_completed",
      search_query: searchQuery,
      store_found: resultsCount > 0,
      city_searched: locationComponents.city,
      region_searched: locationComponents.region,
      country_searched: locationComponents.country,
      number_of_results: resultsCount,
    };
    dataLayer.push(eventData);
  }
  lastSearchQuery = searchQuery;
  lastSearchLocation = locationComponents;
}

function trackResultClick(store, storeIndex, distance = null) {
  if (typeof dataLayer !== "undefined") {
    const eventData = {
      event: "store_locator_result_click",
      store_name: store.name,
      store_city: store.city,
      store_region: store.region || "",
      store_country: store.country,
      store_index: storeIndex,
      city_searched: lastSearchLocation.city,
      region_searched: lastSearchLocation.region,
      country_searched: lastSearchLocation.country,
      distance_km: distance,
    };
    dataLayer.push(eventData);
  }
}

function trackMapsClick(store, storeIndex, distance = null) {
  if (typeof dataLayer !== "undefined") {
    const eventData = {
      event: "store_locator_click_maps",
      store_name: store.name,
      store_city: store.city,
      store_region: store.region || "",
      store_country: store.country,
      store_index: storeIndex,
      city_searched: lastSearchLocation.city,
      region_searched: lastSearchLocation.region,
      country_searched: lastSearchLocation.country,
      distance_km: distance,
    };
    dataLayer.push(eventData);
  }
}

function trackPhoneClick(store, storeIndex, distance = null) {
  if (typeof dataLayer !== "undefined") {
    const eventData = {
      event: "store_locator_click_phone",
      store_name: store.name,
      store_city: store.city,
      store_region: store.region || "",
      store_country: store.country,
      store_index: storeIndex,
      city_searched: lastSearchLocation.city,
      region_searched: lastSearchLocation.region,
      country_searched: lastSearchLocation.country,
      distance_km: distance,
    };
    dataLayer.push(eventData);
  }
}

/* Initialize Google Maps */
function initMap() {
  if (mapInitialized) return;
  if (typeof google === "undefined" || !window.google.maps) return;
  if (!stores || stores.length === 0) return;

  mapInitialized = true;

  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: 37.7749, lng: -122.4194 },
    zoom: 14,
    mapTypeControl: false,
  });

  geocoder = new google.maps.Geocoder();
  addMarkers();
  renderStoreList(stores.slice(0, itemsPerPage));

  /* Fit map to show all markers */
  const bounds = new google.maps.LatLngBounds();
  markers.forEach((marker) => bounds.extend(marker.getPosition()));
  map.fitBounds(bounds);

  /* Modern Marker Clustering Configuration */
  const customRenderer = {
    render: ({ count, position }) => {
      let url = mapcluster1;
      let size = 53;

      if (count >= 10000) {
        url = mapcluster5;
        size = 90;
      } else if (count >= 1000) {
        url = mapcluster4;
        size = 78;
      } else if (count >= 100) {
        url = mapcluster3;
        size = 66;
      } else if (count >= 10) {
        url = mapcluster2;
        size = 56;
      }

      return new google.maps.Marker({
        position,
        icon: {
          url: url,
          scaledSize: new google.maps.Size(size, size),
          size: new google.maps.Size(size, size),
          anchor: new google.maps.Point(size / 2, size / 2),
        },
        label: {
          text: String(count),
          color: "#FFF",
          fontSize: "12px",
          fontWeight: "bold",
        },
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
      });
    },
  };

  markerCluster = new markerClusterer.MarkerClusterer({
    map,
    markers: [],
    renderer: customRenderer,
    algorithm: new markerClusterer.SuperClusterAlgorithm({ maxZoom: 17, radius: 150 }),
  });

  /* Trigger initial filter to cluster active stores correctly */
  const activeStores = filteredStores.length > 0 ? filteredStores : stores;
  filterMarkers(activeStores);

  /* Initialize autocomplete */
  autocomplete = new google.maps.places.Autocomplete(
    document.getElementById("city-active"),
    { types: ["(cities)"] }
  );
  autocomplete.addListener("place_changed", onPlaceChanged);

  /* Get user's current location */
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position) => {
      const userLocation = new google.maps.LatLng(
        position.coords.latitude,
        position.coords.longitude
      );
      map.setCenter(userLocation);
      map.setZoom(14);

      geocoder.geocode({ location: userLocation }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;
          document.getElementById("city-active").value = address;
          filterStoresWithinRadius(userLocation, 20000, true);
        }
      });
    });
  } else {
    alert("Geolocation is not supported by this browser.");
  }

  google.maps.event.addListener(map, "idle", onMapIdle);
}

function onPlaceChanged() {
  const place = autocomplete.getPlace();
  if (!place.geometry) {
    alert("No details available for input: '" + place.name + "'");
    return;
  }

  const location = place.geometry.location;
  map.setCenter(location);
  map.setZoom(14);

  const locationComponents = parseLocationComponents(place);
  const searchQuery = place.formatted_address;

  filterStoresWithinRadius(
    location,
    20000,
    true,
    searchQuery,
    locationComponents
  );
  document.getElementById("city-active").value = place.formatted_address;
}

/* Add markers to the map */
function addMarkers() {
  markers.forEach((marker) => marker.setMap(null));
  markers = [];

  const customIcon = {
    url: markersvg,
    scaledSize: new google.maps.Size(40, 40),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(20, 40),
  };

  stores.forEach((store) => {
    const marker = new google.maps.Marker({
      position: { lat: store.lat, lng: store.lng },
      map: null,
      title: store.name,
      icon: customIcon,
    });

    marker.set("storeId", store.id);
    markers.push(marker);

    marker.addListener("click", () => {
      const storeIndex =
        filteredStores.length > 0
          ? filteredStores.findIndex((s) => s.id === store.id)
          : stores.findIndex((s) => s.id === store.id);

      let distance = null;
      if (lastSearchLocation.city) {
        distance = calculateDistance(
          store.lat,
          store.lng,
          map.getCenter().lat(),
          map.getCenter().lng()
        );
      }

      trackResultClick(store, storeIndex, distance);
      showStoreDetails(store, marker);
      document.getElementById("city-active").value = store.name;
    });
  });

  const activeStores = filteredStores.length > 0 ? filteredStores : stores;
  filterMarkers(activeStores);
}

let currentInfowindow = null;
let activeTooltip = null;

/* Show store details in info window */
function showStoreDetails(store, marker) {
  if (currentInfowindow) {
    currentInfowindow.close();
  }
  selectedStoreId = store.id;
  const targetPos = marker.getPosition();
  const currentPos = map.getCenter();
  const currentZoom = map.getZoom();
  
  const isAlreadyAtTarget = 
    currentZoom === 20 && 
    Math.abs(currentPos.lat() - targetPos.lat()) < 0.00001 && 
    Math.abs(currentPos.lng() - targetPos.lng()) < 0.00001;

  if (!isAlreadyAtTarget) {
    isProgrammaticZoom = true;
    map.setCenter(targetPos);
    map.setZoom(20);
  } else {
    isProgrammaticZoom = false;
  }

  // Trigger marker filter/update immediately so clusters are hidden
  const currentStoreArray = filteredStores.length > 0 ? filteredStores : stores;
  filterMarkers(currentStoreArray);

  const googleMapsLink = `https://www.google.com/maps/search/${store.name}/@${store.lat},${store.lng},17z`;
  let phoneContent = "";

  if (store.phone) {
    phoneContent = `<strong>📞</strong>: <a href="tel:${store.phone}" target="_blank" style="color:#d05a2e;" class="store-phone-link" data-store-id="${store.id}">${store.phone}</a><br>`;
  }

  const infowindow = new google.maps.InfoWindow({
    content: `
            <div class="p-2 pt-4 text-sm">
                <strong>${store.name}</strong><br>
                <strong>🏪</strong>: ${store.address},<br>${store.city}, ${store.pincode} ${store.country}<br>
                ${phoneContent}
                <br><a class="font-bold store-maps-link" href="${googleMapsLink}" target="_blank" data-store-id="${store.id}">View on Google Maps ↗️</a>
            </div>
        `,
  });

  infowindow.open(map, marker);
  activeTooltip = infowindow;
  currentInfowindow = infowindow;

  google.maps.event.addListener(infowindow, "domready", () => {
    const mapsLink = document.querySelector(
      `.store-maps-link[data-store-id="${store.id}"]`
    );
    const phoneLink = document.querySelector(
      `.store-phone-link[data-store-id="${store.id}"]`
    );

    if (mapsLink) {
      mapsLink.addEventListener("click", () => {
        const storeIndex =
          filteredStores.length > 0
            ? filteredStores.findIndex((s) => s.id === store.id)
            : stores.findIndex((s) => s.id === store.id);

        let distance = null;
        if (lastSearchLocation.city) {
          distance = calculateDistance(
            store.lat,
            store.lng,
            map.getCenter().lat(),
            map.getCenter().lng()
          );
        }
        trackMapsClick(store, storeIndex, distance);
      });
    }

    if (phoneLink) {
      phoneLink.addEventListener("click", () => {
        const storeIndex =
          filteredStores.length > 0
            ? filteredStores.findIndex((s) => s.id === store.id)
            : stores.findIndex((s) => s.id === store.id);

        let distance = null;
        if (lastSearchLocation.city) {
          distance = calculateDistance(
            store.lat,
            store.lng,
            map.getCenter().lat(),
            map.getCenter().lng()
          );
        }
        trackPhoneClick(store, storeIndex, distance);
      });
    }
  });

  google.maps.event.addListener(infowindow, "closeclick", () => {
    currentInfowindow = null;
    selectedStoreId = null;

    // Refresh markers to restore clustering when deselected
    const currentStoreArray = filteredStores.length > 0 ? filteredStores : stores;
    filterMarkers(currentStoreArray);
    
    // Immediately update the list to show all visible stores in the viewport
    updateVisibleStores();
  });

  /* Highlight selected store in list */
  const storeItems = document
    .getElementById("store-list")
    .getElementsByTagName("li");
  Array.from(storeItems).forEach((item) => {
    item.classList.remove("selected-store", "text-white", "bg-primary");
    item.classList.add("cursor-pointer");

    if (parseInt(item.getAttribute("data-id")) === store.id) {
      item.classList.add("selected-store", "text-white", "bg-primary");
      item.classList.remove("cursor-pointer");
    }
  });

  document.getElementById("city-active").value = store.name;

  // No timeout needed as the listener is always active and uses programmatic flags.
}

/* Setup scroll listeners for lazy loading */
function setupScrollListeners() {
  const storeList = document.getElementById("store-list");

  /* Remove existing listeners to avoid duplicates */
  storeList.removeEventListener("scroll", onScroll);

  const totalDisplayed = Math.min(
    (currentPage + 1) * itemsPerPage,
    currentListStores.length
  );

  /* Only add scroll listener if there are more items to load */
  if (totalDisplayed < currentListStores.length) {
    storeList.addEventListener("scroll", onScroll);
  }
}

/* Render store list with lazy loading support */
function renderStoreList(storesToRender, isLazyLoading = false) {
  const storeList = document.getElementById("store-list");

  if (!isLazyLoading) {
    storeList.innerHTML = "";
    currentListStores = storesToRender;
  }

  const endIndex = (currentPage + 1) * itemsPerPage;
  storesToRender.slice(0, endIndex).forEach((store) => {
    const li = document.createElement("li");
    const store_name = document.createElement("strong");
    store_name.textContent = store.name;
    li.appendChild(store_name);
    li.innerHTML += `${store.address}`;

    const store_cc = document.createElement("span");
    store_cc.textContent = `${store.city} - ${store.country}`;
    li.appendChild(store_cc);

    if (store.phone) {
      const store_phone = document.createElement("span");
      const phoneLabel = document.createElement("b");
      phoneLabel.textContent = "T. ";
      store_phone.appendChild(phoneLabel);

      const phoneLink = document.createElement("a");
      phoneLink.href = `tel:${store.phone}`;
      phoneLink.textContent = store.phone;
      phoneLink.className = "store-list-phone-link";
      phoneLink.setAttribute("data-store-id", store.id);
      phoneLink.addEventListener("click", () => {
        const storeIndex =
          filteredStores.length > 0
            ? filteredStores.findIndex((s) => s.id === store.id)
            : stores.findIndex((s) => s.id === store.id);

        let distance = null;
        if (lastSearchLocation.city) {
          distance = calculateDistance(
            store.lat,
            store.lng,
            map.getCenter().lat(),
            map.getCenter().lng()
          );
        }
        trackPhoneClick(store, storeIndex, distance);
      });

      store_phone.appendChild(phoneLink);
      li.appendChild(store_phone);
    }

    li.classList.add(
      "text-base",
      "relative",
      "flex",
      "flex-col",
      "px-12",
      "py-6",
      "border-b",
      "cursor-pointer",
      "transition",
      "duration-200"
    );
    li.setAttribute("data-id", store.id);

    li.addEventListener("click", (event) => {
      if (event.target.classList.contains("store-list-phone-link")) return;

      event.stopPropagation();
      const clickedMarker = markers.find(
        (marker) => marker.get("storeId") === store.id
      );

      if (clickedMarker) {
        /* Don't remove zoom listener - just temporarily disable it during the selection process */

        const previouslySelectedStore =
          storeList.querySelector(".selected-store");
        if (previouslySelectedStore) {
          previouslySelectedStore.classList.remove(
            "selected-store",
            "text-white",
            "bg-primary"
          );
          previouslySelectedStore.classList.add("cursor-pointer");
        }

        li.classList.add("selected-store", "text-white", "bg-primary");

        const storeIndex =
          filteredStores.length > 0
            ? filteredStores.findIndex((s) => s.id === store.id)
            : stores.findIndex((s) => s.id === store.id);

        let distance = null;
        if (lastSearchLocation.city) {
          distance = calculateDistance(
            store.lat,
            store.lng,
            map.getCenter().lat(),
            map.getCenter().lng()
          );
        }

        trackResultClick(store, storeIndex, distance);
        showStoreDetails(store, clickedMarker);
        document.getElementById("city-active").value = store.name;

        /* Keep the lazy loading functionality intact */
        setupScrollListeners();
      }
    });

    storeList.appendChild(li);
  });

  document.getElementById(
    "total-stores"
  ).textContent = `${storesToRender.length} shops found`;

  /* Setup scroll listeners after rendering */
  setupScrollListeners();
}

/* Lazy loading for all stores */
function onScroll() {
  const storeList = document.getElementById("store-list");
  if (
    storeList.scrollTop + storeList.clientHeight >=
    storeList.scrollHeight - 10
  ) {
    const totalStores = currentListStores.length;
    const currentlyDisplayed = (currentPage + 1) * itemsPerPage;

    if (currentlyDisplayed < totalStores) {
      currentPage++;
      const newEndIndex = (currentPage + 1) * itemsPerPage;
      const newStores = currentListStores.slice(currentlyDisplayed, newEndIndex);

      /* Append new stores to existing list */
      newStores.forEach((store) => {
        appendStoreToList(store);
      });

      /* Update total count */
      document.getElementById("total-stores").textContent = `${Math.min(
        newEndIndex,
        totalStores
      )} of ${totalStores} shops found`;

      /* Recheck if we need to keep the scroll listener */
      setupScrollListeners();
    }
  }
}

/* Helper function to append a single store to the list (for lazy loading) */
function appendStoreToList(store) {
  const storeList = document.getElementById("store-list");

  const li = document.createElement("li");
  const store_name = document.createElement("strong");
  store_name.textContent = store.name;
  li.appendChild(store_name);
  li.innerHTML += `${store.address}`;

  const store_cc = document.createElement("span");
  store_cc.textContent = `${store.city} - ${store.country}`;
  li.appendChild(store_cc);

  if (store.phone) {
    const store_phone = document.createElement("span");
    const phoneLabel = document.createElement("b");
    phoneLabel.textContent = "T. ";
    store_phone.appendChild(phoneLabel);

    const phoneLink = document.createElement("a");
    phoneLink.href = `tel:${store.phone}`;
    phoneLink.textContent = store.phone;
    phoneLink.className = "store-list-phone-link";
    phoneLink.setAttribute("data-store-id", store.id);
    phoneLink.addEventListener("click", () => {
      const storeIndex =
        filteredStores.length > 0
          ? filteredStores.findIndex((s) => s.id === store.id)
          : stores.findIndex((s) => s.id === store.id);

      let distance = null;
      if (lastSearchLocation.city) {
        distance = calculateDistance(
          store.lat,
          store.lng,
          map.getCenter().lat(),
          map.getCenter().lng()
        );
      }
      trackPhoneClick(store, storeIndex, distance);
    });

    store_phone.appendChild(phoneLink);
    li.appendChild(store_phone);
  }

  li.classList.add(
    "text-base",
    "relative",
    "flex",
    "flex-col",
    "px-12",
    "py-6",
    "border-b",
    "cursor-pointer",
    "transition",
    "duration-200"
  );
  li.setAttribute("data-id", store.id);

  li.addEventListener("click", (event) => {
    if (event.target.classList.contains("store-list-phone-link")) return;

    event.stopPropagation();
    const clickedMarker = markers.find(
      (marker) => marker.get("storeId") === store.id
    );

    if (clickedMarker) {
      const previouslySelectedStore =
        storeList.querySelector(".selected-store");
      if (previouslySelectedStore) {
        previouslySelectedStore.classList.remove(
          "selected-store",
          "text-white",
          "bg-primary"
        );
        previouslySelectedStore.classList.add("cursor-pointer");
      }

      li.classList.add("selected-store", "text-white", "bg-primary");

      const storeIndex =
        filteredStores.length > 0
          ? filteredStores.findIndex((s) => s.id === store.id)
          : stores.findIndex((s) => s.id === store.id);

      let distance = null;
      if (lastSearchLocation.city) {
        distance = calculateDistance(
          store.lat,
          store.lng,
          map.getCenter().lat(),
          map.getCenter().lng()
        );
      }

      trackResultClick(store, storeIndex, distance);
      showStoreDetails(store, clickedMarker);
      document.getElementById("city-active").value = store.name;

      /* Keep the lazy loading functionality intact */
      setupScrollListeners();
    }
  });

  storeList.appendChild(li);
}

/* Update map with filtered stores */
function updateMap(filteredStores2) {
  const bounds = new google.maps.LatLngBounds();

  isProgrammaticZoom = true;
  if (filteredStores2.length === 1) {
    const singleStore = filteredStores2[0];
    const singlePosition = new google.maps.LatLng(
      singleStore.lat,
      singleStore.lng
    );
    map.setCenter(singlePosition);
    map.setZoom(14);
  } else {
    filteredStores2.forEach((store) => {
      const position = new google.maps.LatLng(store.lat, store.lng);
      bounds.extend(position);
    });
    map.fitBounds(bounds);
  }

  filterMarkers(filteredStores2);
}

/* Update visible stores based on map bounds */
function updateVisibleStores() {
  const bounds = map.getBounds();
  if (!bounds) return;
  
  const visibleStores = stores.filter((store) =>
    bounds.contains(new google.maps.LatLng(store.lat, store.lng))
  );
  currentPage = 0;
  renderStoreList(visibleStores);
  filterMarkers(visibleStores); /* Keep markers in sync with list */
}

/* Handle map idle event to update visible stores and handle store deselection */
function onMapIdle() {
  if (isProgrammaticZoom) {
    isProgrammaticZoom = false;
    return;
  }

  const currentZoom = map.getZoom();
  
  // Rule 2: If the user zooms out of the map enough to return to the clustering level (zoom < 18),
  // automatically deselect the store and close its popup.
  if (selectedStoreId !== null && currentZoom < 18) {
    selectedStoreId = null;
    if (currentInfowindow) {
      currentInfowindow.close();
      currentInfowindow = null;
    }
  }

  updateVisibleStores();
}


/* DOM Content Loaded Event Handlers */
document.addEventListener("DOMContentLoaded", () => {
  const cityActiveInput = document.getElementById("city-active");
  const citiesList = document.getElementById("cities-list");
  const cityItems = citiesList.getElementsByTagName("li");
  let blurTimeout;

  citiesList.style.display = "none";

  cityActiveInput.addEventListener("focus", () => {
    trackSearchBarClick();
    if (citiesList.children.length > 0) {
      citiesList.style.display = "block";
    } else {
      citiesList.style.display = "none";
    }
  });

  cityActiveInput.addEventListener("blur", () => {
    blurTimeout = setTimeout(() => {
      citiesList.style.display = "none";
    }, 200);
  });

  citiesList.addEventListener("mousedown", () => {
    clearTimeout(blurTimeout);
  });

  const uniqueCities = [...new Set(stores.map((store) => store.city))];
  populateCitiesList(uniqueCities, citiesList);

  citiesList.addEventListener("click", (event) => {
    if (event.target.tagName === "LI") {
      const selectedCity = event.target.getAttribute("value");
      cityActiveInput.value = selectedCity;

      const cityStores = stores.filter((store) => store.city === selectedCity);
      const locationComponents = {
        city: selectedCity,
        region: "",
        country: cityStores.length > 0 ? cityStores[0].country : "",
      };

      trackSearchCompleted(selectedCity, cityStores.length, locationComponents);
      filterStores(selectedCity);
      citiesList.style.display = "none";
    }
  });

  cityActiveInput.addEventListener("input", (event) => {
    const inputValue = event.target.value.trim().toLowerCase();

    if (activeTooltip) {
      activeTooltip.close();
      activeTooltip = null;
    }
    selectedStoreId = null;

    if (inputValue === "") {
      currentPage = 0;
      filteredStores = [];
      renderStoreList(stores.slice(0, itemsPerPage));
      resetMapAndClusters();

      Array.from(cityItems).forEach((item) => {
        item.style.display = "block";
      });
      return;
    }

    let hasCityMatches = false;
    Array.from(cityItems).forEach((item) => {
      if (item.textContent.toLowerCase().includes(inputValue)) {
        item.style.display = "block";
        hasCityMatches = true;
      } else {
        item.style.display = "none";
      }
    });

    if (hasCityMatches) {
      citiesList.style.display = "block";
    } else {
      citiesList.style.display = "none";
      if (autocomplete) {
        google.maps.event.trigger(cityActiveInput, "focus");
      }
    }

    const filteredStores2 = stores.filter((store) =>
      store.city.toLowerCase().includes(inputValue)
    );

    filteredStores = filteredStores2;
    currentPage = 0;
    renderStoreList(filteredStores2);
    updateMap(filteredStores2);
    filterMarkers(filteredStores2);

    if (filteredStores2.length === 0 && !hasCityMatches) {
      geocoder.geocode({ address: inputValue }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          map.setCenter(location);
          map.setZoom(14);

          const locationComponents = parseLocationComponents({
            address_components: results[0].address_components,
          });

          filterStoresWithinRadius(
            location,
            20000,
            true,
            inputValue,
            locationComponents
          );
        }
      });
    }
  });

  const storeList = document.getElementById("store-list");
  storeList.addEventListener("click", (event) => {
    const li = event.target.closest("li");
    if (li && !event.target.classList.contains("store-list-phone-link")) {
      const previouslySelectedStore =
        storeList.querySelector(".selected-store");
      if (previouslySelectedStore) {
        previouslySelectedStore.classList.remove(
          "selected-store",
          "text-white",
          "bg-primary"
        );
        previouslySelectedStore.classList.add("cursor-pointer");
      }

      const storeId = parseInt(li.getAttribute("data-id"));
      const clickedStore = stores.find((store) => store.id === storeId);
      const clickedMarker = markers.find(
        (marker) => marker.get("storeId") === storeId
      );

      if (clickedStore && clickedMarker) {
        li.classList.add("selected-store", "text-white", "bg-primary");

        const storeIndex =
          filteredStores.length > 0
            ? filteredStores.findIndex((s) => s.id === storeId)
            : stores.findIndex((s) => s.id === storeId);

        let distance = null;
        if (lastSearchLocation.city) {
          distance = calculateDistance(
            clickedStore.lat,
            clickedStore.lng,
            map.getCenter().lat(),
            map.getCenter().lng()
          );
        }

        trackResultClick(clickedStore, storeIndex, distance);
        showStoreDetails(clickedStore, clickedMarker);
        document.getElementById("city-active").value = clickedStore.name;

        /* Ensure lazy loading continues to work */
        setupScrollListeners();
      }
    }
  });

  document
    .querySelector('button[type="reset"]')
    .addEventListener("click", (event) => {
      event.preventDefault();
      cityActiveInput.value = "";
      currentPage = 0;
      filteredStores = [];
      renderStoreList(stores.slice(0, itemsPerPage));
      resetMapAndClusters();
      resetCitiesList(citiesList, uniqueCities);
      lastSearchQuery = "";
      lastSearchLocation = { city: "", region: "", country: "" };
      selectedStoreId = null;

      if (activeTooltip) {
        activeTooltip.close();
        activeTooltip = null;
      }
    });
});

/* Filter stores by selected city */
function filterStores(selectedCity) {
  if (activeTooltip) {
    activeTooltip.close();
    activeTooltip = null;
  }
  selectedStoreId = null;

  filteredStores = stores.filter((store) => store.city === selectedCity);
  currentPage = 0;
  renderStoreList(filteredStores);
  updateMap(filteredStores);
  filterMarkers(filteredStores);
}

/* Filter stores within radius */
function filterStoresWithinRadius(
  location,
  radius,
  alertIfEmpty = false,
  searchQuery = "",
  locationComponents = {}
) {
  if (activeTooltip) {
    activeTooltip.close();
    activeTooltip = null;
  }
  selectedStoreId = null;

  const storesInRadius = stores.filter((store) => {
    const storeLocation = new google.maps.LatLng(store.lat, store.lng);
    return (
      google.maps.geometry.spherical.computeDistanceBetween(
        location,
        storeLocation
      ) <= radius
    );
  });

  if (searchQuery) {
    trackSearchCompleted(
      searchQuery,
      storesInRadius.length,
      locationComponents
    );
  }

  if (storesInRadius.length === 0 && alertIfEmpty) {
    document.getElementById("city-active").value =
      "No stores are available near you.";
    /* alert("No stores are available near you."); */
    /* Reset to show all stores with proper lazy loading */
    filteredStores = [];
    currentPage = 0;
    renderStoreList(stores.slice(0, itemsPerPage));
    resetMapAndClusters();
  } else {
    filteredStores = storesInRadius;
    currentPage = 0;
    renderStoreList(filteredStores);
    updateMap(filteredStores);
    filterMarkers(filteredStores);
  }
}

/* Filter markers visibility */
function filterMarkers(filteredStores2) {
  const isStoreSelected = selectedStoreId !== null;
  const totalVisibleStores = filteredStores2.length;
  
  // Decide whether clustering is enabled
  // Clustering is enabled whenever no store is selected (allowing close-together markers to cluster naturally).
  const isClusteringEnabled = !isStoreSelected;

  if (markerCluster) {
    markerCluster.clearMarkers();
  }

  markers.forEach((marker) => {
    const storeId = marker.get("storeId");
    
    if (isStoreSelected) {
      // If a store is selected, ONLY show that specific store's marker
      if (storeId === selectedStoreId) {
        marker.setVisible(true);
        marker.setMap(map);
      } else {
        marker.setVisible(false);
        marker.setMap(null);
      }
    } else {
      // No store is selected
      const isVisible = filteredStores2.some((store) => store.id === storeId);
      if (isVisible) {
        marker.setVisible(true);
        if (isClusteringEnabled) {
          // Under clustering, individual markers are not placed on the map directly.
          // The clusterer will place them only when not clustered (or when zoom >= 15).
          marker.setMap(null);
        } else {
          // If <= 5 stores, show them individually on the map
          marker.setMap(map);
        }
      } else {
        marker.setVisible(false);
        marker.setMap(null);
      }
    }
  });

  if (markerCluster) {
    if (isClusteringEnabled) {
      markerCluster.setMap(map); // Ensure the clusterer is active on the map
      const filteredMarkers = markers.filter((marker) =>
        filteredStores2.some((store) => store.id === marker.get("storeId"))
      );
      markerCluster.addMarkers(filteredMarkers);
    } else {
      markerCluster.setMap(null); // Detach clusterer to avoid any visual residue when clustering is disabled
    }
  }
}

/* Reset map and clusters */
function resetMapAndClusters() {
  selectedStoreId = null;
  markers.forEach((marker) => marker.setMap(null));
  if (markerCluster) {
    markerCluster.clearMarkers();
    markerCluster.setMap(null);
  }
  addMarkers();

  const bounds = new google.maps.LatLngBounds();
  markers.forEach((marker) => bounds.extend(marker.getPosition()));
  
  isProgrammaticZoom = true;
  map.fitBounds(bounds);

  /* Reset filtered stores to empty array so lazy loading works with all stores */
  filteredStores = [];
}

/* Show all stores */
function showAllStores() {
  currentPage = 0;
  filteredStores = [];
  renderStoreList(stores.slice(0, itemsPerPage));
  updateMap(stores);
}

/* Find nearest store to user location */
function findNearestStore(userLocation, stores2) {
  let nearestStore = null;
  let minDistance = Infinity;

  stores2.forEach((store) => {
    const storeLocation = new google.maps.LatLng(store.lat, store.lng);
    const distance = google.maps.geometry.spherical.computeDistanceBetween(
      userLocation,
      storeLocation
    );

    if (distance < minDistance) {
      nearestStore = store;
      minDistance = distance;
    }
  });

  return nearestStore;
}

/* Populate cities list */
function populateCitiesList(uniqueCities, citiesList) {
  citiesList.innerHTML = "";
  uniqueCities.forEach((city) => {
    const listItem = document.createElement("li");
    listItem.classList.add("cursor-pointer");
    listItem.textContent = city;
    listItem.setAttribute("value", city);
    citiesList.appendChild(listItem);
  });
}

/* Reset cities list */
function resetCitiesList(citiesList, uniqueCities) {
  populateCitiesList(uniqueCities, citiesList);
}